import type {
  DrawingToolInstance,
  SingleTimestampCoordinates,
  ChartLayout,
  TimestampToX,
} from "./types";
import { applyLineStyle, drawHandleCircle } from "./drawHelpers";

export function getVerticalLineHandleY(layout: ChartLayout): number {
  return layout.top + (layout.height - layout.top - layout.bottom) / 2;
}

export function drawVerticalLine(
  ctx: CanvasRenderingContext2D,
  coords: SingleTimestampCoordinates,
  instance: DrawingToolInstance,
  layout: ChartLayout,
  timestampToX: TimestampToX,
  draggingTimestamp?: number,
) {
  const timestamp = draggingTimestamp ?? coords.timestamp;
  const x = timestampToX(timestamp) + 2;
  const chartRight = layout.width - layout.right;
  if (x < layout.left || x > chartRight) return;

  applyLineStyle(ctx, instance.mainLine.color, instance.mainLine.width, instance.mainLine.opacity);
  ctx.beginPath();
  ctx.moveTo(x, layout.top);
  ctx.lineTo(x, layout.height - layout.bottom);
  ctx.stroke();

  drawHandleCircle(ctx, x, getVerticalLineHandleY(layout), instance.mainLine.color);
}
